import { defineStore } from 'pinia';
import axios from '@client/helper/http';
import { training } from '../api';
import queryString from 'query-string';
export const scheduleStore = defineStore('schedule', {
  state() {
    return {
      scheduleLoading: false,
      openedSidePanel: 'closed',
      programs: [],
      activeScheduleData: {},
      activeCalendCardData: {
        weekIndex: 0,
        dayIndex: 0,
        index: 0,
        happenDay: ''
      },
      activeCalendCardSportData: {
        // entities: {},
        // program: {}
      },
      maxIdInPlan: 1,
      maxPlanProgramId: 1,
      maxIdInPlanEdit: 1,
      site: 'schedule', // schedule,plan
      scheduleModalOperateType: 'add' // 操作类型, add, edit
    };
  },
  actions: {
    fetchTraningScheduleList(data = {}) {
      this.scheduleLoading = true;
      return axios.get(`${training.schedule}`, { params: data }).then((res) => {
        this.scheduleLoading = false;
        return res.data;
      });
    },
    updateOpendSidePanel(name) {
      this.openedSidePanel = name;
    },
    fetchScheduleSumData(data) {
      return axios.get(`${training.querysum}`, { params: data }).then((res) => {
        return res.data;
      });
    },
    updateSchedule(data, params = {}) {
      const url = queryString.stringifyUrl({ url: training.update, query: params });
      return axios({
        method: 'post',
        url,
        data,
        params
      }).then((res) => {
        return res.data;
      });
    },
    updatePrograms(data = []) {
      this.programs = data;
    },
    fetchProgramDetail(data) {
      return axios.get(`${training.detail}`, { params: data }).then((res) => {
        return res.data;
      });
    },
    fetchPlanList(params, data) {
      const url = queryString.stringifyUrl({ url: training.plan, query: params });
      return axios.post(url, data).then((res) => {
        return res.data;
      });
    },
    uploadPlanFile(data) {
      return axios.post(training.import, data).then((res) => {
        return res.data;
      });
    },
    fetchPlanDetail(data) {
      return axios.get(training.planDetail, { params: data }).then((res) => {
        return res.data;
      });
    },
    addPlan(data) {
      return axios.post(training.addPlan, data).then((res) => {
        return res.data;
      });
    },
    updatePlan(data, params = {}) {
      const url = queryString.stringifyUrl({ url: training.updatePlan, query: params });
      return axios.post(url, data).then((res) => {
        return res.data;
      });
    },
    executeSubPlan(params, data = {}) {
      const url = queryString.stringifyUrl({ url: training.executeSubPlan, query: params });

      return axios.post(url, data).then((res) => {
        return res.data;
      });
    },
    copyPlan(params, data) {
      const url = queryString.stringifyUrl({ url: training.copyPlan, query: params });
      return axios.post(url, data).then((res) => {
        return res.data;
      });
    },
    updateActiveScheduleData(data) {
      this.activeScheduleData = data;
    },
    updateMaxIdInPlan(id) {
      this.maxIdInPlan = Number(id);
    },
    updateMaxPlanProgramId(id) {
      this.maxPlanProgramId = Number(id);
    },
    updateMaxIdPlanEdit(id) {
      this.maxIdInPlanEdit = Number(id);
    },
    updateScheduleModalOperateType(type) {
      this.scheduleModalOperateType = type;
    },
    updateCalendCardData(data) {
      this.activeCalendCardData = data;
    },
    updateCalendCardSportData(data) {
      this.activeCalendCardSportData = data;
    },
    calculateProgram(data) {
      return axios.post(training.calculate, data).then((res) => {
        return res.data;
      });
    },
    updateSite(site) {
      this.site = site;
    }
  }
});
